var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white",
    fillOpacity: 0.39
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46,
    height: 46,
    rx: 23,
    stroke: "white",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.8446V29.1557C16 30.1514 16 30.6485 16.1938 31.0288C16.3642 31.3633 16.636 31.636 16.9705 31.8064C17.3504 32 17.848 32 18.8417 32H29.1583C30.152 32 30.6489 32 31.0288 31.8064C31.3633 31.636 31.636 31.3633 31.8064 31.0288C32 30.6489 32 30.152 32 29.1583V18.8417C32 17.848 32 17.3504 31.8064 16.9705C31.636 16.636 31.3633 16.3642 31.0288 16.1938C30.6485 16 30.1514 16 29.1557 16H18.8446C17.849 16 17.3508 16 16.9705 16.1938C16.636 16.3642 16.3642 16.636 16.1938 16.9705C16 17.3508 16 17.849 16 18.8446Z",
    stroke: "#1F6FA0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.785a44ab11d6b621c5f6d8512ee0760a.svg";
export { ForwardRef as ReactComponent };